"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.THANKS = void 0;
const THANKS = exports.THANKS = 'thanks';
